export default __webpack_public_path__ + "static/SNSW logo-110f3dc791882e8d242a02d8c9435595.png";